module.exports = __webpack_public_path__ + "img/ink_iphone_x_banner.d2151bdd.png";